// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --c64-black: #000000;
  --c64-white: #ffffff;
  --c64-red: #880000;
  --c64-cyan: #aaffee;
  --c64-purple: #cc44cc;
  --c64-green: #00cc55;
  --c64-blue: #0000aa;
  --c64-yellow: #eeee77;
  --c64-orange: #dd8855;
  --c64-brown: #664400;
  --c64-light-red: #ff7777;
  --c64-dark-grey: #333333;
  --c64-grey: #777777;
  --c64-light-green: #aaff66;
  --c64-light-blue: #0088ff;
  --c64-light-grey: #bbbbbb;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  user-select: none;
  -webkit-user-select: none;
}

html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #000000;
  color: var(--c64-white);
  font-family: 'Press Start 2P', monospace, sans-serif;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Fix for iOS Safari: use svh/dvh where supported for correct viewport height */
  height: 100dvh;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: none;
}

/* 16:9 Widescreen Full-Screen Arcade Container */
.arcade-cabinet {
  position: relative;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  max-width: 100vw;
  max-height: 100vh;
  max-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  padding: 0;
  margin: 0;
}

.cabinet-bezel {
  position: relative;
  width: 100vw;
  height: 56.25vw; /* 16:9 ratio (9 / 16 = 0.5625) */
  max-height: 100vh;
  max-height: 100dvh;
  max-width: 177.78vh; /* 16:9 ratio (16 / 9 = 1.7778) */
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  overflow: hidden;
}

#game-canvas {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #000000;
  cursor: crosshair;
}

/* Top Arcade HUD with Solid Black Background */
.c64-hud {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #000000;
  border: 2px solid #222222;
  border-radius: 4px;
  padding: 6px 18px;
  gap: 28px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.95);
  z-index: 10;
  pointer-events: none;
}

.hud-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #000000;
}

.hud-label {
  font-size: 11px;
  color: var(--c64-yellow);
  text-shadow: 1px 1px 0 #000;
}

.hud-val {
  font-size: 11px;
  color: var(--c64-cyan);
  text-shadow: 1px 1px 0 #000;
}

/* Modal and Screen Panels */
.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  backdrop-filter: blur(3px);
  transition: opacity 0.2s ease;
}

.modal-overlay.hidden {
  display: none;
}

.screen-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
  width: 90%;
  max-width: 480px;
  background: #000000;
  border: 3px solid var(--c64-light-blue);
  box-shadow: 0 0 30px rgba(0, 136, 255, 0.4), inset 0 0 15px rgba(0, 0, 0, 0.9);
  border-radius: 6px;
}

.screen-panel.hidden {
  display: none;
}

.logo-wrapper {
  margin-bottom: 12px;
  width: 100%;
}

.c64-logo {
  max-width: 100%;
  max-height: 130px;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.8);
}

.boss-art-wrapper {
  margin-bottom: 12px;
  width: 100%;
}

.doh-art {
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 0 15px var(--c64-purple);
  border: 2px solid var(--c64-cyan);
}

.c64-banner {
  font-size: 9px;
  color: var(--c64-yellow);
  letter-spacing: 1px;
  margin-bottom: 18px;
  text-shadow: 1px 1px 0 #000;
}

.c64-heading {
  font-size: 16px;
  color: var(--c64-yellow);
  margin-bottom: 14px;
  text-shadow: 2px 2px 0 var(--c64-red);
}

.c64-heading.red {
  color: var(--c64-light-red);
  text-shadow: 2px 2px 0 #000;
}

.c64-heading.cyan {
  color: var(--c64-cyan);
  text-shadow: 2px 2px 0 var(--c64-blue);
}

.c64-subtext {
  font-size: 9px;
  color: var(--c64-light-green);
  margin-bottom: 16px;
  line-height: 1.6;
}

.c64-info {
  font-size: 8px;
  color: var(--c64-light-grey);
  margin-top: 10px;
}

.score-summary {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 11px;
  margin: 16px 0;
  color: var(--c64-white);
}

.score-summary .highlight {
  color: var(--c64-cyan);
}

/* Settings Page */
.settings-group {
  width: 100%;
  margin-bottom: 16px;
  text-align: left;
}

.settings-title {
  font-size: 8px;
  color: var(--c64-yellow);
  margin-bottom: 6px;
  text-transform: uppercase;
}

.settings-buttons, .settings-toggles {
  display: flex;
  gap: 6px;
  width: 100%;
}

.settings-buttons .c64-btn, .settings-toggles .c64-btn {
  flex: 1;
  padding: 8px 6px;
  font-size: 8px;
}

/* Button Styles */
.menu-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.c64-btn {
  background: #111116;
  border: 2px solid var(--c64-cyan);
  color: var(--c64-white);
  padding: 10px 14px;
  font-family: inherit;
  font-size: 9px;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 2px 2px 0 #000;
}

.c64-btn:hover {
  background: var(--c64-cyan);
  color: var(--c64-black);
  transform: translate(-1px, -1px);
  box-shadow: 3px 3px 0 #000;
}

.c64-btn:active {
  transform: translate(2px, 2px);
  box-shadow: 0 0 0 #000;
}

.c64-btn.active {
  background: var(--c64-light-blue);
  border-color: var(--c64-yellow);
  color: var(--c64-white);
  box-shadow: 2px 2px 0 var(--c64-blue);
}

.c64-btn.muted {
  border-color: var(--c64-red);
  color: var(--c64-red);
}

.start-btn {
  background: var(--c64-red);
  border-color: var(--c64-yellow);
  color: var(--c64-white);
  padding: 12px 20px;
  font-size: 11px;
}

.start-btn:hover {
  background: var(--c64-yellow);
  color: var(--c64-red);
}

.secondary-btn {
  background: #1b162b;
  border-color: var(--c64-purple);
  color: var(--c64-white);
}

.secondary-btn:hover {
  background: var(--c64-purple);
  color: var(--c64-white);
}

.controls-guide {
  margin-top: 16px;
  font-size: 7px;
  color: var(--c64-grey);
  line-height: 1.8;
}

.pulse {
  animation: retroPulse 1.2s infinite ease-in-out;
}

@keyframes retroPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.85; transform: scale(1.02); }
}

/* Quick Bar (Bottom Right): Fullscreen button */
.quick-bar {
  position: absolute;
  bottom: 12px;
  right: 14px;
  display: flex;
  gap: 8px;
  z-index: 15;
}

.c64-pill-btn {
  background: #000000;
  border: 1px solid var(--c64-grey);
  color: var(--c64-light-grey);
  font-family: inherit;
  font-size: 8px;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.8);
}

.c64-pill-btn:hover {
  border-color: var(--c64-cyan);
  color: var(--c64-cyan);
}

/* Cheat Level Select Grid */
.cheat-level-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  width: 100%;
  margin-top: 10px;
}

.cheat-level-btn {
  font-size: 7px !important;
  padding: 8px 4px !important;
  text-align: center;
  border-color: var(--c64-purple) !important;
  background: #1a0a2e !important;
  color: var(--c64-cyan) !important;
}

.cheat-level-btn:hover {
  background: var(--c64-purple) !important;
  color: var(--c64-white) !important;
  border-color: var(--c64-yellow) !important;
}

/* ===== Mobile & Touch Device Optimizations ===== */

/* Prevent iOS Safari overscroll / bounce */
html {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}

/* Safe-area insets for notched devices (iPhone X+) */
@supports (padding: env(safe-area-inset-top)) {
  .arcade-cabinet {
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }

  .cabinet-bezel {
    max-width: calc(177.78vh - env(safe-area-inset-left) - env(safe-area-inset-right));
    max-height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  }
}

/* Mobile portrait orientation warning & responsive adjustments */
@media (max-width: 768px) {
  .c64-hud {
    padding: 4px 10px;
    gap: 12px;
    top: 4px;
  }

  .hud-label, .hud-val {
    font-size: 8px;
  }

  .screen-panel {
    padding: 14px;
    max-width: 95%;
    max-height: 90vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .c64-heading {
    font-size: 12px;
    margin-bottom: 8px;
  }

  .c64-subtext {
    font-size: 7px;
    margin-bottom: 10px;
  }

  .c64-btn {
    padding: 8px 10px;
    font-size: 8px;
  }

  .start-btn {
    padding: 10px 16px;
    font-size: 10px;
  }

  .c64-logo {
    max-height: 80px;
  }

  .doh-art {
    max-height: 80px;
  }

  .controls-guide {
    font-size: 6px;
    margin-top: 8px;
  }

  .settings-buttons, .settings-toggles {
    flex-wrap: wrap;
  }

  .settings-buttons .c64-btn, .settings-toggles .c64-btn {
    font-size: 7px;
    padding: 6px 4px;
  }

  .cheat-level-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 5px;
  }

  .cheat-level-btn {
    font-size: 6px !important;
    padding: 6px 2px !important;
  }
}

/* Very small screens (phones in portrait) */
@media (max-width: 480px) and (orientation: portrait) {
  .screen-panel {
    padding: 10px;
    max-height: 85vh;
  }

  .c64-heading {
    font-size: 10px;
  }

  .menu-actions {
    gap: 6px;
  }

  .c64-logo {
    max-height: 60px;
  }

  .cheat-level-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Landscape mobile */
@media (max-height: 450px) {
  .screen-panel {
    padding: 8px 14px;
    max-height: 95vh;
  }

  .c64-logo {
    max-height: 50px;
  }

  .doh-art {
    max-height: 60px;
  }

  .c64-heading {
    font-size: 11px;
    margin-bottom: 6px;
  }

  .c64-subtext {
    font-size: 7px;
    margin-bottom: 6px;
  }

  .c64-hud {
    padding: 3px 8px;
    gap: 10px;
    top: 2px;
  }

  .hud-label, .hud-val {
    font-size: 7px;
  }

  .logo-wrapper {
    margin-bottom: 4px;
  }

  .c64-banner {
    margin-bottom: 8px;
  }

  .menu-actions {
    gap: 5px;
  }

  .controls-guide {
    margin-top: 6px;
    font-size: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gFAAgF;EAChF,cAAc;EACd,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe,EAAE,iCAAiC;EAClD,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB,EAAE,iCAAiC;EACtD,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,0CAA0C;EAC1C,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,4BAA4B;EAC5B,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA,oDAAoD;;AAEpD,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,uCAAuC;IACvC,yCAAyC;EAC3C;;EAEA;IACE,kFAAkF;IAClF,gFAAgF;EAClF;AACF;;AAEA,iEAAiE;AACjE;EACE;IACE,iBAAiB;IACjB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');\n\n:root {\n  --c64-black: #000000;\n  --c64-white: #ffffff;\n  --c64-red: #880000;\n  --c64-cyan: #aaffee;\n  --c64-purple: #cc44cc;\n  --c64-green: #00cc55;\n  --c64-blue: #0000aa;\n  --c64-yellow: #eeee77;\n  --c64-orange: #dd8855;\n  --c64-brown: #664400;\n  --c64-light-red: #ff7777;\n  --c64-dark-grey: #333333;\n  --c64-grey: #777777;\n  --c64-light-green: #aaff66;\n  --c64-light-blue: #0088ff;\n  --c64-light-grey: #bbbbbb;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\nhtml, body {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  background: #000000;\n  color: var(--c64-white);\n  font-family: 'Press Start 2P', monospace, sans-serif;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Fix for iOS Safari: use svh/dvh where supported for correct viewport height */\n  height: 100dvh;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: none;\n}\n\n/* 16:9 Widescreen Full-Screen Arcade Container */\n.arcade-cabinet {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  height: 100dvh;\n  max-width: 100vw;\n  max-height: 100vh;\n  max-height: 100dvh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000000;\n  padding: 0;\n  margin: 0;\n}\n\n.cabinet-bezel {\n  position: relative;\n  width: 100vw;\n  height: 56.25vw; /* 16:9 ratio (9 / 16 = 0.5625) */\n  max-height: 100vh;\n  max-height: 100dvh;\n  max-width: 177.78vh; /* 16:9 ratio (16 / 9 = 1.7778) */\n  aspect-ratio: 16 / 9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000000;\n  overflow: hidden;\n}\n\n#game-canvas {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  background: #000000;\n  cursor: crosshair;\n}\n\n/* Top Arcade HUD with Solid Black Background */\n.c64-hud {\n  position: absolute;\n  top: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  background: #000000;\n  border: 2px solid #222222;\n  border-radius: 4px;\n  padding: 6px 18px;\n  gap: 28px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.95);\n  z-index: 10;\n  pointer-events: none;\n}\n\n.hud-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #000000;\n}\n\n.hud-label {\n  font-size: 11px;\n  color: var(--c64-yellow);\n  text-shadow: 1px 1px 0 #000;\n}\n\n.hud-val {\n  font-size: 11px;\n  color: var(--c64-cyan);\n  text-shadow: 1px 1px 0 #000;\n}\n\n/* Modal and Screen Panels */\n.modal-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 20;\n  backdrop-filter: blur(3px);\n  transition: opacity 0.2s ease;\n}\n\n.modal-overlay.hidden {\n  display: none;\n}\n\n.screen-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 24px;\n  width: 90%;\n  max-width: 480px;\n  background: #000000;\n  border: 3px solid var(--c64-light-blue);\n  box-shadow: 0 0 30px rgba(0, 136, 255, 0.4), inset 0 0 15px rgba(0, 0, 0, 0.9);\n  border-radius: 6px;\n}\n\n.screen-panel.hidden {\n  display: none;\n}\n\n.logo-wrapper {\n  margin-bottom: 12px;\n  width: 100%;\n}\n\n.c64-logo {\n  max-width: 100%;\n  max-height: 130px;\n  object-fit: contain;\n  border-radius: 4px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.8);\n}\n\n.boss-art-wrapper {\n  margin-bottom: 12px;\n  width: 100%;\n}\n\n.doh-art {\n  max-width: 100%;\n  max-height: 150px;\n  object-fit: contain;\n  border-radius: 4px;\n  box-shadow: 0 0 15px var(--c64-purple);\n  border: 2px solid var(--c64-cyan);\n}\n\n.c64-banner {\n  font-size: 9px;\n  color: var(--c64-yellow);\n  letter-spacing: 1px;\n  margin-bottom: 18px;\n  text-shadow: 1px 1px 0 #000;\n}\n\n.c64-heading {\n  font-size: 16px;\n  color: var(--c64-yellow);\n  margin-bottom: 14px;\n  text-shadow: 2px 2px 0 var(--c64-red);\n}\n\n.c64-heading.red {\n  color: var(--c64-light-red);\n  text-shadow: 2px 2px 0 #000;\n}\n\n.c64-heading.cyan {\n  color: var(--c64-cyan);\n  text-shadow: 2px 2px 0 var(--c64-blue);\n}\n\n.c64-subtext {\n  font-size: 9px;\n  color: var(--c64-light-green);\n  margin-bottom: 16px;\n  line-height: 1.6;\n}\n\n.c64-info {\n  font-size: 8px;\n  color: var(--c64-light-grey);\n  margin-top: 10px;\n}\n\n.score-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font-size: 11px;\n  margin: 16px 0;\n  color: var(--c64-white);\n}\n\n.score-summary .highlight {\n  color: var(--c64-cyan);\n}\n\n/* Settings Page */\n.settings-group {\n  width: 100%;\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n.settings-title {\n  font-size: 8px;\n  color: var(--c64-yellow);\n  margin-bottom: 6px;\n  text-transform: uppercase;\n}\n\n.settings-buttons, .settings-toggles {\n  display: flex;\n  gap: 6px;\n  width: 100%;\n}\n\n.settings-buttons .c64-btn, .settings-toggles .c64-btn {\n  flex: 1;\n  padding: 8px 6px;\n  font-size: 8px;\n}\n\n/* Button Styles */\n.menu-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.c64-btn {\n  background: #111116;\n  border: 2px solid var(--c64-cyan);\n  color: var(--c64-white);\n  padding: 10px 14px;\n  font-family: inherit;\n  font-size: 9px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  box-shadow: 2px 2px 0 #000;\n}\n\n.c64-btn:hover {\n  background: var(--c64-cyan);\n  color: var(--c64-black);\n  transform: translate(-1px, -1px);\n  box-shadow: 3px 3px 0 #000;\n}\n\n.c64-btn:active {\n  transform: translate(2px, 2px);\n  box-shadow: 0 0 0 #000;\n}\n\n.c64-btn.active {\n  background: var(--c64-light-blue);\n  border-color: var(--c64-yellow);\n  color: var(--c64-white);\n  box-shadow: 2px 2px 0 var(--c64-blue);\n}\n\n.c64-btn.muted {\n  border-color: var(--c64-red);\n  color: var(--c64-red);\n}\n\n.start-btn {\n  background: var(--c64-red);\n  border-color: var(--c64-yellow);\n  color: var(--c64-white);\n  padding: 12px 20px;\n  font-size: 11px;\n}\n\n.start-btn:hover {\n  background: var(--c64-yellow);\n  color: var(--c64-red);\n}\n\n.secondary-btn {\n  background: #1b162b;\n  border-color: var(--c64-purple);\n  color: var(--c64-white);\n}\n\n.secondary-btn:hover {\n  background: var(--c64-purple);\n  color: var(--c64-white);\n}\n\n.controls-guide {\n  margin-top: 16px;\n  font-size: 7px;\n  color: var(--c64-grey);\n  line-height: 1.8;\n}\n\n.pulse {\n  animation: retroPulse 1.2s infinite ease-in-out;\n}\n\n@keyframes retroPulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.85; transform: scale(1.02); }\n}\n\n/* Quick Bar (Bottom Right): Fullscreen button */\n.quick-bar {\n  position: absolute;\n  bottom: 12px;\n  right: 14px;\n  display: flex;\n  gap: 8px;\n  z-index: 15;\n}\n\n.c64-pill-btn {\n  background: #000000;\n  border: 1px solid var(--c64-grey);\n  color: var(--c64-light-grey);\n  font-family: inherit;\n  font-size: 8px;\n  padding: 6px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.15s;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.8);\n}\n\n.c64-pill-btn:hover {\n  border-color: var(--c64-cyan);\n  color: var(--c64-cyan);\n}\n\n/* Cheat Level Select Grid */\n.cheat-level-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 8px;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.cheat-level-btn {\n  font-size: 7px !important;\n  padding: 8px 4px !important;\n  text-align: center;\n  border-color: var(--c64-purple) !important;\n  background: #1a0a2e !important;\n  color: var(--c64-cyan) !important;\n}\n\n.cheat-level-btn:hover {\n  background: var(--c64-purple) !important;\n  color: var(--c64-white) !important;\n  border-color: var(--c64-yellow) !important;\n}\n\n/* ===== Mobile & Touch Device Optimizations ===== */\n\n/* Prevent iOS Safari overscroll / bounce */\nhtml {\n  overflow: hidden;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n\n/* Safe-area insets for notched devices (iPhone X+) */\n@supports (padding: env(safe-area-inset-top)) {\n  .arcade-cabinet {\n    padding-top: env(safe-area-inset-top);\n    padding-bottom: env(safe-area-inset-bottom);\n    padding-left: env(safe-area-inset-left);\n    padding-right: env(safe-area-inset-right);\n  }\n\n  .cabinet-bezel {\n    max-width: calc(177.78vh - env(safe-area-inset-left) - env(safe-area-inset-right));\n    max-height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n  }\n}\n\n/* Mobile portrait orientation warning & responsive adjustments */\n@media (max-width: 768px) {\n  .c64-hud {\n    padding: 4px 10px;\n    gap: 12px;\n    top: 4px;\n  }\n\n  .hud-label, .hud-val {\n    font-size: 8px;\n  }\n\n  .screen-panel {\n    padding: 14px;\n    max-width: 95%;\n    max-height: 90vh;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .c64-heading {\n    font-size: 12px;\n    margin-bottom: 8px;\n  }\n\n  .c64-subtext {\n    font-size: 7px;\n    margin-bottom: 10px;\n  }\n\n  .c64-btn {\n    padding: 8px 10px;\n    font-size: 8px;\n  }\n\n  .start-btn {\n    padding: 10px 16px;\n    font-size: 10px;\n  }\n\n  .c64-logo {\n    max-height: 80px;\n  }\n\n  .doh-art {\n    max-height: 80px;\n  }\n\n  .controls-guide {\n    font-size: 6px;\n    margin-top: 8px;\n  }\n\n  .settings-buttons, .settings-toggles {\n    flex-wrap: wrap;\n  }\n\n  .settings-buttons .c64-btn, .settings-toggles .c64-btn {\n    font-size: 7px;\n    padding: 6px 4px;\n  }\n\n  .cheat-level-grid {\n    grid-template-columns: repeat(5, 1fr);\n    gap: 5px;\n  }\n\n  .cheat-level-btn {\n    font-size: 6px !important;\n    padding: 6px 2px !important;\n  }\n}\n\n/* Very small screens (phones in portrait) */\n@media (max-width: 480px) and (orientation: portrait) {\n  .screen-panel {\n    padding: 10px;\n    max-height: 85vh;\n  }\n\n  .c64-heading {\n    font-size: 10px;\n  }\n\n  .menu-actions {\n    gap: 6px;\n  }\n\n  .c64-logo {\n    max-height: 60px;\n  }\n\n  .cheat-level-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* Landscape mobile */\n@media (max-height: 450px) {\n  .screen-panel {\n    padding: 8px 14px;\n    max-height: 95vh;\n  }\n\n  .c64-logo {\n    max-height: 50px;\n  }\n\n  .doh-art {\n    max-height: 60px;\n  }\n\n  .c64-heading {\n    font-size: 11px;\n    margin-bottom: 6px;\n  }\n\n  .c64-subtext {\n    font-size: 7px;\n    margin-bottom: 6px;\n  }\n\n  .c64-hud {\n    padding: 3px 8px;\n    gap: 10px;\n    top: 2px;\n  }\n\n  .hud-label, .hud-val {\n    font-size: 7px;\n  }\n\n  .logo-wrapper {\n    margin-bottom: 4px;\n  }\n\n  .c64-banner {\n    margin-bottom: 8px;\n  }\n\n  .menu-actions {\n    gap: 5px;\n  }\n\n  .controls-guide {\n    margin-top: 6px;\n    font-size: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
